/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t=(t,n,o)=>{const r=n-t;return((o-t)%r+r)%r+t};export{t as wrap};
//# sourceMappingURL=wrap.js.map
